import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'
import { map, take } from 'rxjs'

import { SiteStore } from '@app/store/site.store'

export const countryCodeRedirectGuard: CanActivateFn = (_, state) => {
  const siteStore = inject(SiteStore)
  const router = inject(Router)

  return siteStore.data$.pipe(
    take(1),
    map(data =>
      data.site.non_core_country && data.site.country_code
        ? router.parseUrl(`/${data.site.country_code}${state.url}`)
        : true,
    ),
  )
}
